// extracted by mini-css-extract-plugin
module.exports = {"cart":"CartWidget-module--cart--3aodN","cartEmpty":"CartWidget-module--cartEmpty--LvDK7"};